import { render, staticRenderFns } from "./ShowMensagem.vue?vue&type=template&id=4dea76b0&lang=pug&"
import script from "./ShowMensagem.vue?vue&type=script&lang=js&"
export * from "./ShowMensagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports